module.exports = __webpack_public_path__ + "img/raffle.465a7119.svg";